import React from 'react';
import { formatShortDay } from '../../fields.utils';
import { Bar, Text, BackButton } from './RecordBar.styles';

export const RecordBar = ({ survey, onBack }) => (
  <Bar data-testid='record-bar'>
    <b>Finalised {formatShortDay(survey.closed_on)}</b>
    <Text>
      This is the record of a survey that is closed. Nothing here changes again.
    </Text>
    <BackButton type='button' onClick={onBack}>
      Back to the current survey
    </BackButton>
  </Bar>
);
